import React from 'react';

// 이미지 확장자 목록
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'];

// URL에서 확장자 추출
const getFileExtension = (url) => {
    if (!url) return '';
    const cleanUrl = url.split('?')[0]; // 쿼리스트링 제거
    const parts = cleanUrl.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

// URL에서 파일명 추출
const getFileName = (url) => {
    if (!url) return '';
    const cleanUrl = url.split('?')[0];
    const parts = cleanUrl.split('/');
    const fullName = parts.pop() || '';
    // 인덱스 접두사 제거 (예: "0-filename.txt" -> "filename.txt")
    return fullName.replace(/^\d+-/, '');
};

// 이미지 파일인지 확인
const isImageFile = (url) => {
    const ext = getFileExtension(url);
    return IMAGE_EXTENSIONS.includes(ext);
};

// 확장자별 아이콘 색상
const getFileColor = (ext) => {
    const colorMap = {
        'pdf': '#e53935',
        'doc': '#1565c0', 'docx': '#1565c0',
        'xls': '#2e7d32', 'xlsx': '#2e7d32', 'csv': '#2e7d32',
        'txt': '#616161',
        'json': '#f9a825', 'xml': '#f9a825',
        'html': '#e65100', 'css': '#0277bd', 'js': '#f9a825',
        'md': '#424242',
        'zip': '#6a1b9a', 'rar': '#6a1b9a', '7z': '#6a1b9a',
    };
    return colorMap[ext] || '#757575';
};

// ThumbnailViewer 컴포넌트 정의
export default function ThumbnailViewer({ images }) {
    // images 배열이 비어있지 않은지 확인
    if (!images || images.length === 0) {
        return <p>No images available.</p>;
    }

    return (
        <div style={styles.container}>
            {images.map((fileSrc, index) => {
                if (isImageFile(fileSrc)) {
                    // 이미지 파일
                    return (
                        <div key={index} style={styles.thumbnailWrapper}>
                            <img
                                src={fileSrc}
                                alt={`Thumbnail ${index + 1}`}
                                style={styles.thumbnail}
                            />
                        </div>
                    );
                } else {
                    // 이미지가 아닌 파일
                    const ext = getFileExtension(fileSrc);
                    const fileName = getFileName(fileSrc);
                    const fileColor = getFileColor(ext);

                    return (
                        <div key={index} style={styles.thumbnailWrapper}>
                            <a
                                href={fileSrc}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={styles.fileLink}
                            >
                                <div style={styles.fileIconContainer}>
                                    <svg width="36" height="42" viewBox="0 0 36 42" fill="none" style={styles.fileSvg}>
                                        <path d="M2 2h20l12 12v26a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2z" fill="#f5f5f5" stroke={fileColor} strokeWidth="1.5"/>
                                        <path d="M22 2v12h12" fill="#e0e0e0" stroke={fileColor} strokeWidth="1.5"/>
                                    </svg>
                                    <span style={{ ...styles.fileExtLabel, color: fileColor }}>
                                        {ext.toUpperCase()}
                                    </span>
                                </div>
                                <span style={styles.fileName}>{fileName}</span>
                            </a>
                        </div>
                    );
                }
            })}
        </div>
    );
}

// 간단한 스타일 객체
const styles = {
    container: {
        margin: '25px 30px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    thumbnailWrapper: {
        border: '1px solid #ddd',
        padding: '10px',
        borderRadius: '8px',
        width: '100px',
        height: '120px',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff',
    },
    thumbnail: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'cover',
    },
    fileLink: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textDecoration: 'none',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    },
    fileIconContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    fileSvg: {
        marginBottom: '2px',
    },
    fileExtLabel: {
        fontSize: '9px',
        fontWeight: '700',
        marginTop: '-20px',
        letterSpacing: '0.5px',
    },
    fileName: {
        fontSize: '10px',
        color: '#555',
        textAlign: 'center',
        marginTop: '6px',
        wordBreak: 'break-all',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        lineHeight: '1.2',
        maxWidth: '100%',
    },
};